const numberFormat = (value: number, language: string): string =>
	new Intl.NumberFormat(language == 'nl' ? 'nl-NL' : 'en-EN', {
		style: 'currency',
		currency: 'EUR'
	}).format(value)

export default numberFormat
